import * as React from 'react';
import {useState} from 'react';
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import {Box, InputBase} from "@mui/material";
import DefaultTable from "./defaultTable";
import { default as axios } from 'axios'
import {EditorState, StateList} from "../main/config";
import { TextareaAutosize } from '@mui/material';
//import NavBar from '../main/Components/NavigationBar/NavBar';
import NavBar from '../main/Components/NavigationBar/NavBar';
import Alert from './alert';
import styles from './editor.module.scss'
import {api} from "../utils/useAxios";

//CREATE row WHERE topic = $topic, header = $header, data = associated column info
async function sendToDatabase(data) {
    try {
        await api({
            method: 'post',
            url: 'upsertOpusData',
            data: data,
        }).then( response => {
            console.log(response);
        })
    } catch (e) {
        if(e) console.log(e);
    }
}


export default function CreateTopic(props): JSX.Element {
    const {csvData, data, pickedStates} = props;
    const [latestKey, setLatestKey] = useState(EditorState.latestKey);
    const [description, setDescription] = useState("");
    const [lastUpdated, setLastUpdated] = useState("");
    const [isShowingAlert, setShowingAlert] = useState(EditorState.alert);

    //Alert helper function
    function setAlert(alert) {
        setShowingAlert({...alert})
    }

    //Helper function for managing unique keys in a list
    function getNewKey(latest) {
        let newKey = latest + 1;
        setLatestKey(newKey);
        return newKey;
    }

    //Create the data object for the initial table
    StateList.map( state => {
        let stateKey = state.value;
        let obj = {}
        let colKeys = Object.keys(EditorState.table.headers);
        obj["state"] = state.label;
        colKeys.map( key => {
            return obj[key] = "";
        })
        EditorState.table.data[stateKey] = obj;
    })

    //States for table and topic
    const [table, setTable] = useState(EditorState.table);
    const [topic, setTopic] = useState(EditorState.topic);

    const Description = (props) => {
        let { desc } = props;
        const [value, setValue] = useState(desc)
        return <TextareaAutosize
            onChange={(e) => { setValue(e.target.value); } }
            onBlur={(e) => { setDescription(e.target.value); } }
            value={value}
            placeholder={"Input description here..."}      />
    }

    const LastUpdated = (props) => {
        let { last } = props;
        const [value, setValue] = useState(last)
        return <TextareaAutosize
            className={styles.lastUpdated}
            onChange={(e) => { setValue(e.target.value); } }
            onBlur={(e) => { setLastUpdated(e.target.value); } }
            value={value}
            placeholder={"Last updated..."}     />
    }


    //handles the changes to body cells
    function handleDataChange(e, rowKey, headerKey) {
        let tempTable = table;
        tempTable.data[rowKey][headerKey] = e.currentTarget.value;
        setTable(tempTable);
    }

    //handles the changes to the header labels
    function handleHeaderChange(e, headerKey) {
        let tempTable = table;
        tempTable.headers[headerKey] = e.currentTarget.value;
        setTable(tempTable);
    }

    //handles adding a column to the table
    function handleColumnAdd() {
        let tempTable = table;
        let newKey = getNewKey(latestKey)
        tempTable.headers[newKey] = "";
        if(Object.keys(tempTable.data).length === 0) 
            {        
            StateList.map( state => {
            let stateKey = state.value;
            let obj = {}
            let colKeys = Object.keys(tempTable.headers);
            obj["state"] = state.label;
            colKeys.map( key => {
                return obj[key] = "";
            })
            tempTable.data[stateKey] = obj;
        })}
        //add a new column to each row
        const rows = Object.keys(tempTable.data);
        rows.forEach( row => {
            tempTable.data[row][newKey] = "";
        })
        setTable(tempTable);
    }

    //handles removing a column from the table
    function handleColumnRemove(e) {
        let target = e.currentTarget.id;
        let tempTable = table;
        delete tempTable.headers[target];
        let rows = Object.keys(tempTable.data);
        rows.forEach( row => {
            delete tempTable.data[row][target]
        })
        if(Object.keys(tempTable.headers).length === 0) {
            tempTable.data = {};
        }
        setTable({headers: tempTable.headers, data: {...tempTable.data}});
    }

    //Handles submission of the new topic into the db
    function submitData () {
        let rowKeys = Object.keys(table.headers);
        //check if any column names are empty
        if( Object.values(table.headers).includes("") ) {
            setAlert({send: true, message: "Enter Column Headers Before Submitting", isSubmit: false});
            return;
        }
        if(!topic) {
            if(!description) {
                setAlert({send: true, message: "Enter Topic And Description Before Submitting",  isSubmit: false})
            } else {
                setAlert({send: true, message: "Enter Topic Before Submitting", isSubmit: false})
            }
        } else if(!description) {
            setAlert({send: true, message: "Enter Description Before Submitting", isSubmit: false})
        } 
        else if(rowKeys.length === 0) {
            setAlert({send: true, message: "Add Columns Before Submitting", isSubmit: false})
        }
        else {
            rowKeys.map( key => {
                let dataToSubmit = {
                    header: table.headers[key],
                    topic: topic,
                    description: description,
                    lastupdated: lastUpdated
                }
                StateList.map( state => {
                    let value = table.data[state.value][key];
                    if(!value) {
                        dataToSubmit[state.value] = "";
                    } else {
                        dataToSubmit[state.value] = value;
                    }
                } )
                sendToDatabase(dataToSubmit).then(() => {
                    setAlert({send: true, message: "Topic Successfully Created!", isSubmit: true})
                })
            })
        }
    }

    //Create Topic component wrapper for <DefaultTable />
    return(
        <div>
            <NavBar 
                csvData={csvData}
                data={data}
                pickedStates={pickedStates}
            />
            <Box className={styles.editor}>
                <Alert setAlert={setAlert} isShowingAlert={isShowingAlert} />
                <Grid container spacing={2} style={{ textAlign: "center" }}>
                    <Grid item xs={3}>
                        <Box
                            component="form"
                            noValidate
                            autoComplete="off"
                            sx={{ flexGrow: 1 }}
                        >
                             <div
                            className={styles.selectMenuLabel}
                           >
                                Topics
                        </div>
                            <InputBase
                                className={styles.topic}
                                onBlur={(e) => {setTopic(e.target.value)}}                            
                                color='secondary'
                            />
                        </Box>
                    </Grid>
                    
                    <Grid item xs={1} className={styles.editSubmit}>
                        <Button className={styles.submit} onClick={submitData}>Submit Topic</Button>
                    </Grid>
                    <Grid item xs={4} className={styles.TopicTitle}>
                        {topic}
                    </Grid>

        {/* Empty grid for spacing purposes */}
                    <Grid item xs />
                    <Grid item xs={2}>
                    <div className={styles.lastUpdatedLabel}>
                            Last Updated
                        </div>
                        <LastUpdated last={lastUpdated} />
                    </Grid>

                    <Grid item xs={12}>
                        <div className={styles.descriptionLabel}>
                            Description
                        </div>
                        <div className={styles.description}>
                        <Description desc={description} />
                        </div>
                    </Grid>
                    
                    <Grid item xs={12}>
                        <DefaultTable
                            table={table}
                            updateHeaders={handleHeaderChange}
                            updateData={handleDataChange}
                            addColumn={handleColumnAdd}
                            removeColumn={handleColumnRemove}
                        />
                    </Grid>
                </Grid>
            </Box>
        </div>

    )
};
